import { Grid, Typography } from '@mui/material';
import { map } from 'es-toolkit/compat';

import React from 'react';
import { useQCImpacts } from 'utils/queryHooks/useQCMarkers';
import ImpactIcon from './ImpactIcon';

const LegendQCImpact: React.FC = () => {
  const { data: qcImpactOptions } = useQCImpacts();

  return (
    <Grid container spacing={2} sx={{ mt: 3 }}>
      {map(qcImpactOptions, (qcImpactOption) => (
        <Grid item container direction="row" spacing={1} key={qcImpactOption.id}>
          <Grid item display="flex" alignItems="center">
            <ImpactIcon qcImpactId={qcImpactOption.id} />
          </Grid>
          <Grid item>
            <Typography variant="body1" fontWeight="bold">
              {qcImpactOption.name}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>{qcImpactOption.description}</Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default LegendQCImpact;
